var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.94,289.78A76.88,76.88,0,0,1,458.32,271c8-16.38,13.75-30.71,8.66-49-12.47-44.67-63.19-49.89-88.21-83.58-38.68-52.06-133.72-56.58-179.12-11.59-13.92,13.79-20.44,33.27-34.51,46.91-20.73,20.11-51.51,22.7-72.8,42.75-34.71,32.71-38.08,88.14-7.27,124.92,32.54,38.84,78.47,32.47,123.08,24.21,21.95-4.06,44.77-8.46,67.14-5.34C323,367,379.61,393.21,425.85,367.12c24.63-13.9,25.26-35.58,24.69-60.87A75.31,75.31,0,0,1,451.94,289.78Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.94,289.78A76.88,76.88,0,0,1,458.32,271c8-16.38,13.75-30.71,8.66-49-12.47-44.67-63.19-49.89-88.21-83.58-38.68-52.06-133.72-56.58-179.12-11.59-13.92,13.79-20.44,33.27-34.51,46.91-20.73,20.11-51.51,22.7-72.8,42.75-34.71,32.71-38.08,88.14-7.27,124.92,32.54,38.84,78.47,32.47,123.08,24.21,21.95-4.06,44.77-8.46,67.14-5.34C323,367,379.61,393.21,425.85,367.12c24.63-13.9,25.26-35.58,24.69-60.87A75.31,75.31,0,0,1,451.94,289.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.5,
    cy: 385.5,
    rx: 191.5,
    ry: 40.5,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.5,
    cy: 385.5,
    rx: 191.5,
    ry: 40.5,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.05,114.14a6.24,6.24,0,0,1,5-7.82c5.23-.71,11.65,6.31,13.69,10.56.17.37,2.26,6.43,2.16,6.43s-9.27.21-13-1.45C43.63,120.45,39.92,117.76,39.05,114.14ZM173.37,98c-.77,3.64-4.41,6.43-7.59,7.93s-10.73,1.76-12.58,1.79c-1,1.19-2.07,2.48-3.22,3.92-2,2.56-4.22,5.47-6.42,8.79-.59.89-1.19,1.86-1.79,2.8,1.34-1.37,3.19-3.22,3.39-3.38,3.69-2.93,12.53-6.44,16.92-3.52a6.24,6.24,0,0,1,1.1,9.22c-2.37,2.88-6.88,3.68-10.4,3.54s-10.55-3.49-12.05-4.24c-1.29,2.09-2.57,4.27-3.77,6.62a80.28,80.28,0,0,0-5.53,13.23l.27.13c1.07-1.41,3.4-4.32,3.62-4.53,3.34-3.33,11.75-7.78,16.44-5.37a6.25,6.25,0,0,1,2.09,9c-2,3.13-6.43,4.42-9.94,4.66-4,.29-12.41-2.87-12.73-3a110.83,110.83,0,0,0-3,13.93c-.54,3.48-.95,7-1.33,10.59.73-1,3.79-4.83,4-5.08,3.34-3.32,11.75-7.78,16.43-5.36a6.24,6.24,0,0,1,2.1,9.05c-2,3.12-6.43,4.41-9.94,4.65-3.95.28-12-2.71-12.66-3-.17,1.62-.34,3.23-.5,4.86-.52,5.29-1,10.61-1.66,15.84-.23,1.81-.51,3.59-.79,5.37,1.14-1.48,3.26-4.13,3.47-4.34,3.34-3.32,11.75-7.78,16.44-5.36a6.24,6.24,0,0,1,2.09,9c-2,3.12-6.43,4.41-9.94,4.66s-10.33-2.12-12.24-2.82c-.49,3-1,5.89-1.72,8.74-.32,1.23-.56,2.5-.94,3.66l-1,3.49c-.8,2.36-1.53,4.55-2.33,6.73-.4,1.1-.79,2.13-1.19,3.2.93-1.68,2.45-4.3,2.61-4.53,2.8-3.79,10.43-9.46,15.43-7.78a6.23,6.23,0,0,1,3.45,8.62c-1.54,3.4-5.69,5.34-9.13,6.11-3.78.86-11.9-.79-12.89-1-1,2.61-2,5.13-2.94,7.48-3,7.43-5.85,13.51-7.88,17.74l-.33.68h14.79l-5.11,99.6A14.22,14.22,0,0,1,100.22,364h0A14.23,14.23,0,0,1,86,350.5l-5.11-99.6H96.77c-.08-.69-.16-1.42-.25-2.24-.53-4.6-1.39-11.18-2.77-19-.39-2.26-.84-4.65-1.34-7.1-1,.13-9.22,1.17-12.93,0-3.36-1-7.36-3.28-8.64-6.78a6.24,6.24,0,0,1,4.08-8.34c5.11-1.31,12.3,4.93,14.81,8.91.16.26,1.71,3.49,2.47,5.16-.3-1.48-.59-2.95-.93-4.49-.48-2.21-1-4.53-1.59-6.79-.32-1.16-.65-2.33-1-3.51s-.75-2.3-1.12-3.48c-.58-1.7-1.27-3.43-2-5.16-2.22.62-8.78,2.31-12.15,1.82s-7.78-2.12-9.57-5.38a6.24,6.24,0,0,1,2.77-8.87c4.85-2.07,12.9,3,16,6.57.1.11.68.93,1.35,1.91-.72-1.66-1.43-3.33-2.21-5-2.22-4.72-4.63-9.47-7-14.23-.5-1-1-2-1.48-3-1.87.53-9,2.43-12.49,1.92s-7.78-2.12-9.57-5.39A6.24,6.24,0,0,1,54,159.6c4.85-2.06,12.9,3,16,6.58.11.12.8,1.1,1.55,2.21-1.26-2.61-2.49-5.22-3.63-7.86a112.13,112.13,0,0,1-5-13.86c-.65.19-8.92,2.59-12.85,2-3.48-.5-7.77-2.12-9.56-5.38a6.24,6.24,0,0,1,2.76-8.87c4.86-2.06,12.91,3,16,6.57.22.26,2.66,3.82,3.49,5.13a1.09,1.09,0,0,1,0-.17,81.2,81.2,0,0,1-2.4-14.27A112.61,112.61,0,0,1,60,118.75c.1-4,.43-7.66.75-10.89.19-1.75.39-3.35.6-4.84l-.09.06c-.09.06-1.85-6.1-1.92-6.5-.78-4.65.46-14.08,5.14-16.51a6.25,6.25,0,0,1,8.6,3.53c1.36,3.47-.14,7.8-2,10.81s-8,7.38-9.5,8.43c-.18,1.55-.36,3.21-.52,5-.25,3.23-.5,6.88-.51,10.87,0,1.07,0,2.21.05,3.32.36-1.88.89-4.44,1-4.69,1.45-4.48,6.89-12.28,12.17-12.27a6.24,6.24,0,0,1,6,7.09c-.38,3.71-3.71,6.86-6.72,8.69S62.29,123.81,60.63,124c.08,2.46.21,5,.51,7.6a80.77,80.77,0,0,0,2.68,14.08l.3,0c.12-1.77.46-5.48.52-5.79,1-4.61,5.5-13,10.75-13.53a6.24,6.24,0,0,1,6.74,6.39c0,3.72-2.93,7.23-5.72,9.37-3.22,2.47-11.94,4.45-12.27,4.52a109,109,0,0,0,5.15,13.3c1.47,3.2,3.08,6.39,4.73,9.57.06-1.25.5-6.12.57-6.47,1-4.61,5.5-13,10.75-13.54a6.25,6.25,0,0,1,6.74,6.39c0,3.73-2.94,7.23-5.73,9.37-3.14,2.41-11.48,4.35-12.19,4.51.75,1.44,1.5,2.89,2.26,4.33,2.49,4.71,5,9.41,7.36,14.13.81,1.64,1.55,3.28,2.3,4.92.13-1.87.45-5.25.5-5.54,1-4.61,5.51-13,10.75-13.54a6.24,6.24,0,0,1,6.74,6.39c0,3.73-2.93,7.23-5.72,9.37s-9.79,3.93-11.76,4.41C87.82,197,89,199.7,90,202.46c.41,1.2.9,2.39,1.23,3.56l1.06,3.49c.63,2.41,1.23,4.64,1.77,6.9.28,1.14.51,2.22.77,3.32-.15-1.9-.33-4.93-.32-5.21.25-4.7,3.48-13.65,8.58-15a6.24,6.24,0,0,1,7.63,5.3,7.87,7.87,0,0,1,.09,1.38A24.25,24.25,0,0,1,114,218c0,.3-.49,3.85-.78,5.66.57-1.4,1.13-2.79,1.69-4.25.83-2.11,1.63-4.36,2.43-6.54l1.12-3.47c.4-1.17.64-2.33,1-3.52.46-1.74.84-3.57,1.22-5.38-2.19-.72-8.6-2.92-11.14-5.19s-5.31-6.06-5-9.77a6.25,6.25,0,0,1,7.2-5.87c5.19,1,9.11,9.63,9.71,14.3,0,.15.05,1.15.07,2.34.32-1.78.65-3.57.91-5.39.76-5.16,1.36-10.45,2-15.74.13-1.11.28-2.21.41-3.31-1.85-.59-8.81-2.91-11.47-5.29s-5.31-6.06-5-9.77a6.23,6.23,0,0,1,7.2-5.87c5.19,1,9.1,9.63,9.71,14.3,0,.16,0,1.36.07,2.7.38-2.88.8-5.73,1.31-8.56A109,109,0,0,1,130.13,145c-.66-.2-8.87-2.76-11.83-5.4-2.63-2.35-5.32-6.06-5-9.77a6.23,6.23,0,0,1,7.2-5.87c5.18,1,9.1,9.63,9.71,14.3,0,.33.11,4.65.08,6.2,0-.06,0-.12.05-.17a81.92,81.92,0,0,1,5.87-13.23,112.93,112.93,0,0,1,6.88-11c2.29-3.29,4.58-6.15,6.64-8.67,1.12-1.36,2.17-2.58,3.16-3.71h-.11c-.1,0,1.83-6.12,2-6.49,1.92-4.3,8.15-11.49,13.39-10.93A6.24,6.24,0,0,1,173.37,98ZM112.88,224.6c-.9-.43-7.81-3.85-10.51-6.78a66.75,66.75,0,0,1-7.22,3.39c.61,2.72,1.19,5.37,1.68,7.86,1.56,7.88,2.57,14.5,3.21,19.15.13,1,.25,1.87.35,2.68h.35l1.16-2.25c2.09-4.13,5-10.09,8.18-17.39C111,229.16,111.94,226.92,112.88,224.6Zm27.64-100.7c.08,0,1.68-6.15,1.74-6.56.65-4.66-.84-14.06-5.59-16.36a6.25,6.25,0,0,0-8.5,3.77c-1.27,3.5.35,7.79,2.26,10.74C132.67,119,140.51,123.9,140.52,123.9Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.05,114.14a6.24,6.24,0,0,1,5-7.82c5.23-.71,11.65,6.31,13.69,10.56.17.37,2.26,6.43,2.16,6.43s-9.27.21-13-1.45C43.63,120.45,39.92,117.76,39.05,114.14ZM173.37,98c-.77,3.64-4.41,6.43-7.59,7.93s-10.73,1.76-12.58,1.79c-1,1.19-2.07,2.48-3.22,3.92-2,2.56-4.22,5.47-6.42,8.79-.59.89-1.19,1.86-1.79,2.8,1.34-1.37,3.19-3.22,3.39-3.38,3.69-2.93,12.53-6.44,16.92-3.52a6.24,6.24,0,0,1,1.1,9.22c-2.37,2.88-6.88,3.68-10.4,3.54s-10.55-3.49-12.05-4.24c-1.29,2.09-2.57,4.27-3.77,6.62a80.28,80.28,0,0,0-5.53,13.23l.27.13c1.07-1.41,3.4-4.32,3.62-4.53,3.34-3.33,11.75-7.78,16.44-5.37a6.25,6.25,0,0,1,2.09,9c-2,3.13-6.43,4.42-9.94,4.66-4,.29-12.41-2.87-12.73-3a110.83,110.83,0,0,0-3,13.93c-.54,3.48-.95,7-1.33,10.59.73-1,3.79-4.83,4-5.08,3.34-3.32,11.75-7.78,16.43-5.36a6.24,6.24,0,0,1,2.1,9.05c-2,3.12-6.43,4.41-9.94,4.65-3.95.28-12-2.71-12.66-3-.17,1.62-.34,3.23-.5,4.86-.52,5.29-1,10.61-1.66,15.84-.23,1.81-.51,3.59-.79,5.37,1.14-1.48,3.26-4.13,3.47-4.34,3.34-3.32,11.75-7.78,16.44-5.36a6.24,6.24,0,0,1,2.09,9c-2,3.12-6.43,4.41-9.94,4.66s-10.33-2.12-12.24-2.82c-.49,3-1,5.89-1.72,8.74-.32,1.23-.56,2.5-.94,3.66l-1,3.49c-.8,2.36-1.53,4.55-2.33,6.73-.4,1.1-.79,2.13-1.19,3.2.93-1.68,2.45-4.3,2.61-4.53,2.8-3.79,10.43-9.46,15.43-7.78a6.23,6.23,0,0,1,3.45,8.62c-1.54,3.4-5.69,5.34-9.13,6.11-3.78.86-11.9-.79-12.89-1-1,2.61-2,5.13-2.94,7.48-3,7.43-5.85,13.51-7.88,17.74l-.33.68h14.79l-5.11,99.6A14.22,14.22,0,0,1,100.22,364h0A14.23,14.23,0,0,1,86,350.5l-5.11-99.6H96.77c-.08-.69-.16-1.42-.25-2.24-.53-4.6-1.39-11.18-2.77-19-.39-2.26-.84-4.65-1.34-7.1-1,.13-9.22,1.17-12.93,0-3.36-1-7.36-3.28-8.64-6.78a6.24,6.24,0,0,1,4.08-8.34c5.11-1.31,12.3,4.93,14.81,8.91.16.26,1.71,3.49,2.47,5.16-.3-1.48-.59-2.95-.93-4.49-.48-2.21-1-4.53-1.59-6.79-.32-1.16-.65-2.33-1-3.51s-.75-2.3-1.12-3.48c-.58-1.7-1.27-3.43-2-5.16-2.22.62-8.78,2.31-12.15,1.82s-7.78-2.12-9.57-5.38a6.24,6.24,0,0,1,2.77-8.87c4.85-2.07,12.9,3,16,6.57.1.11.68.93,1.35,1.91-.72-1.66-1.43-3.33-2.21-5-2.22-4.72-4.63-9.47-7-14.23-.5-1-1-2-1.48-3-1.87.53-9,2.43-12.49,1.92s-7.78-2.12-9.57-5.39A6.24,6.24,0,0,1,54,159.6c4.85-2.06,12.9,3,16,6.58.11.12.8,1.1,1.55,2.21-1.26-2.61-2.49-5.22-3.63-7.86a112.13,112.13,0,0,1-5-13.86c-.65.19-8.92,2.59-12.85,2-3.48-.5-7.77-2.12-9.56-5.38a6.24,6.24,0,0,1,2.76-8.87c4.86-2.06,12.91,3,16,6.57.22.26,2.66,3.82,3.49,5.13a1.09,1.09,0,0,1,0-.17,81.2,81.2,0,0,1-2.4-14.27A112.61,112.61,0,0,1,60,118.75c.1-4,.43-7.66.75-10.89.19-1.75.39-3.35.6-4.84l-.09.06c-.09.06-1.85-6.1-1.92-6.5-.78-4.65.46-14.08,5.14-16.51a6.25,6.25,0,0,1,8.6,3.53c1.36,3.47-.14,7.8-2,10.81s-8,7.38-9.5,8.43c-.18,1.55-.36,3.21-.52,5-.25,3.23-.5,6.88-.51,10.87,0,1.07,0,2.21.05,3.32.36-1.88.89-4.44,1-4.69,1.45-4.48,6.89-12.28,12.17-12.27a6.24,6.24,0,0,1,6,7.09c-.38,3.71-3.71,6.86-6.72,8.69S62.29,123.81,60.63,124c.08,2.46.21,5,.51,7.6a80.77,80.77,0,0,0,2.68,14.08l.3,0c.12-1.77.46-5.48.52-5.79,1-4.61,5.5-13,10.75-13.53a6.24,6.24,0,0,1,6.74,6.39c0,3.72-2.93,7.23-5.72,9.37-3.22,2.47-11.94,4.45-12.27,4.52a109,109,0,0,0,5.15,13.3c1.47,3.2,3.08,6.39,4.73,9.57.06-1.25.5-6.12.57-6.47,1-4.61,5.5-13,10.75-13.54a6.25,6.25,0,0,1,6.74,6.39c0,3.73-2.94,7.23-5.73,9.37-3.14,2.41-11.48,4.35-12.19,4.51.75,1.44,1.5,2.89,2.26,4.33,2.49,4.71,5,9.41,7.36,14.13.81,1.64,1.55,3.28,2.3,4.92.13-1.87.45-5.25.5-5.54,1-4.61,5.51-13,10.75-13.54a6.24,6.24,0,0,1,6.74,6.39c0,3.73-2.93,7.23-5.72,9.37s-9.79,3.93-11.76,4.41C87.82,197,89,199.7,90,202.46c.41,1.2.9,2.39,1.23,3.56l1.06,3.49c.63,2.41,1.23,4.64,1.77,6.9.28,1.14.51,2.22.77,3.32-.15-1.9-.33-4.93-.32-5.21.25-4.7,3.48-13.65,8.58-15a6.24,6.24,0,0,1,7.63,5.3,7.87,7.87,0,0,1,.09,1.38A24.25,24.25,0,0,1,114,218c0,.3-.49,3.85-.78,5.66.57-1.4,1.13-2.79,1.69-4.25.83-2.11,1.63-4.36,2.43-6.54l1.12-3.47c.4-1.17.64-2.33,1-3.52.46-1.74.84-3.57,1.22-5.38-2.19-.72-8.6-2.92-11.14-5.19s-5.31-6.06-5-9.77a6.25,6.25,0,0,1,7.2-5.87c5.19,1,9.11,9.63,9.71,14.3,0,.15.05,1.15.07,2.34.32-1.78.65-3.57.91-5.39.76-5.16,1.36-10.45,2-15.74.13-1.11.28-2.21.41-3.31-1.85-.59-8.81-2.91-11.47-5.29s-5.31-6.06-5-9.77a6.23,6.23,0,0,1,7.2-5.87c5.19,1,9.1,9.63,9.71,14.3,0,.16,0,1.36.07,2.7.38-2.88.8-5.73,1.31-8.56A109,109,0,0,1,130.13,145c-.66-.2-8.87-2.76-11.83-5.4-2.63-2.35-5.32-6.06-5-9.77a6.23,6.23,0,0,1,7.2-5.87c5.18,1,9.1,9.63,9.71,14.3,0,.33.11,4.65.08,6.2,0-.06,0-.12.05-.17a81.92,81.92,0,0,1,5.87-13.23,112.93,112.93,0,0,1,6.88-11c2.29-3.29,4.58-6.15,6.64-8.67,1.12-1.36,2.17-2.58,3.16-3.71h-.11c-.1,0,1.83-6.12,2-6.49,1.92-4.3,8.15-11.49,13.39-10.93A6.24,6.24,0,0,1,173.37,98ZM112.88,224.6c-.9-.43-7.81-3.85-10.51-6.78a66.75,66.75,0,0,1-7.22,3.39c.61,2.72,1.19,5.37,1.68,7.86,1.56,7.88,2.57,14.5,3.21,19.15.13,1,.25,1.87.35,2.68h.35l1.16-2.25c2.09-4.13,5-10.09,8.18-17.39C111,229.16,111.94,226.92,112.88,224.6Zm27.64-100.7c.08,0,1.68-6.15,1.74-6.56.65-4.66-.84-14.06-5.59-16.36a6.25,6.25,0,0,0-8.5,3.77c-1.27,3.5.35,7.79,2.26,10.74C132.67,119,140.51,123.9,140.52,123.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-1--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.61,159.26s-9.78,7.48-11.13,13.24.39,11.89,1.54,15.54,1.34,21.3-9.4,29.16-15.54,15.73-14.39,25.52,15.73,20.53,27.82,23,29.16-3.07,35.87-17.46S451.62,218,446.63,209s-4.6-17.46,1-17.84,8.44,1,8.64-6.91-1.73-20.14-11.9-26.28S423.61,159.26,423.61,159.26Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,255.76c1,.67,10,4.34,16.66-6s-2.41-19.87-.66-29",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55,171.16s-3.12-10.08,3.64-6.81c7.25,3.5,13,20,10.5,23.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.69,169.85s-3.75-7.25-1.25-10.5,8.25.5,11.25,2.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.19,189.6s1,4.5-2,13.5-8.5,19.25-3,28.75,9.75,16,3.5,25.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.19,194.85a81.09,81.09,0,0,1-1.25,17.5c-1.75,10,3.75,16.5,9.5,22.75s4.25,11.5,2.25,17.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.44,171.35s-11.75,1-15.25-.5-2.75-2.75-2.75-2.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,211.29s1.53,15.54,3.49,24.53,5.08,20.34,4.3,23.47-18,29.72-18,29.72l-5.08-3.52,10.56-31.68-8.89-29.7S428.52,212.18,434,211.29Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.63,208.76c-2.5-2.88-7.87-10.36-7.87-10.36l-8.44-10-11.7-16.11c-1.54-2.11-6.72-1.35-21.68-1.15s-60.37-8.44-60.37-8.44l-1.53,10s41.56,9,52.11,10,20.34,2.3,20.34,2.3a87.48,87.48,0,0,0-3.84,8.83c-1.15,3.45-14.58,21.87-14.58,21.87s-.33.2-.9.58c-.15,3.34.17,10.43,5.16,14.17,3.86,2.89,9.51,4.11,13.59,4.62h0c.07-.23.13-.43.18-.57.58-1.54,4.8-3.84,7.1-4s9.4.19,13.63-.19,6.52-6.14,6.52-6.14,9.32-9.1,13.61-12.82A7.34,7.34,0,0,0,432.63,208.76Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "398.8 187.32 393.49 184.97 397.35 191.11",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,222.26a20.47,20.47,0,0,0,13.39,2.91",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,215.27s.87,3.5,6.41,5.83",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.24,253.81s3.63-1.56,6.54,2.52",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "430.25 226.63 420.35 224.11 429.08 231",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.17,176s-4.95,8.73-10.77,8.44c-7.91-.4-30.29-7-30.29-9.32s6.12-3.2,6.12-3.2",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.35,183.24s-4-1-6.91.77-10.55,18.42-10.55,18.42.57.77,2.88.77,2.88,3.07,2.88,5.94-.2,4.22.76,4,6.72-2.3,7.87-1.53-1.54,4.6-1,5,5.37-4.42,6.91-9.6,3.07-12.85,2.68-15.92S423,184,420.35,183.24Z",
    style: {
      fill: "#F68989",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,199.17a86.93,86.93,0,0,1-6.71,6.71c-4.42,4-8.06,6.91-7.87,5s4.6-12.28,5.75-18,3.27-9.6,5.57-9.6S427.64,195,423.61,199.17Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.31,174.42a3.49,3.49,0,0,0,1.92,2.11c1.34.38,11.32-5.37,11.32-5.37s7.1,15.15,5.94,17.45-4.6,5.19-8.44,7.87-10.93,4.8-13.62,3.26-.77-17.26-.77-17.26-2.11-2.5.19-6.53S421.31,174.42,421.31,174.42Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.38,190.07s.17-1.19-2.05-1.19-6.12,4.08-6.12,4.08",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.68,
    y1: 193.3,
    x2: 426.49,
    y2: 192.11,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,195.52s-3.06-.51-3.57-4.43",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.08,183.89s-.76-3.73-4-4.45",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.23,185.89c-.78.61-1.64.81-1.93.44s.1-1.16.87-1.77,1.64-.81,1.93-.44S430,185.28,429.23,185.89Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.05,192.19c-.64.5-1.35.67-1.59.36s.08-1,.72-1.47,1.35-.66,1.59-.36S434.69,191.68,434.05,192.19Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.38,355.47l9.81,13.63s0,2.5-3.5,2.5-5.5,0-7.5-2.5-2-4-4-5-4-1-3-6.5S415.38,355.47,415.38,355.47Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.15,369.41a8.53,8.53,0,0,1-5,.74c-3.54-.64-5.69-4.18-7-5.7s-2.91-1.51-4.42-2.78a9.85,9.85,0,0,1-1.86-2.12c-.21,3.56,1.52,3.68,3.24,4.55,2,1,2,2.5,4,5s4,2.5,7.5,2.5C424.42,371.6,425,370.08,425.15,369.41Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.82,353.74c-2-6-4.85-41.92-6.33-53.29-3-23.12-16.34-53.13-16.34-53.13l.77-12.28c-4.08-.51-9.73-1.73-13.59-4.62-5-3.74-5.31-10.83-5.16-14.17-2.53,1.63-10,6.54-16.37,11.7-7.86,6.33-13.24,28.78-14.77,35.87s-3.26,28-3.26,28-13.82,5.37-19.38,13-22.45,24.94-22.45,24.94l1.54,5.76s5.18-3.64,9.59-7.1,38.76-22.64,41.06-24,5-4,8.06-11.7c1.12-2.81,2.7-7.41,4.26-12.12L367.78,264l5.13-4.37c5.06,13.68,16.82,40.05,18.49,43.82,2,4.52,3.52,24.62,9.05,37.19s7,18.6,7,18.6S416.83,359.77,414.82,353.74Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.59,
    y1: 237.41,
    x2: 394.5,
    y2: 248.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,151.29,93.3,396.59a1.9,1.9,0,0,0,2.88,1.83L114.74,387a5,5,0,0,1,6.79,1.47l23.32,34.67,9.73-145.84Z",
    style: {
      fill: "#F68989",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,157.46l-26.1,233a2.6,2.6,0,0,0,4.13,2.38l13.57-10a6.45,6.45,0,0,1,9.23,1.65l15.88,24.24a1.43,1.43,0,0,0,2.63-.89L122.8,157.47A.41.41,0,0,0,122,157.46Z",
    style: {
      fill: "#F68989",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.36,154.08,95.88,390.44a2.6,2.6,0,0,0,4.13,2.38l13.57-10a6.45,6.45,0,0,1,9.23,1.65l15.88,24.24a1.43,1.43,0,0,0,2.63-.89L122.55,154.08A.1.1,0,0,0,122.36,154.08Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,381.54a6.45,6.45,0,0,1,5.28,2.91l15.88,24.24a1.43,1.43,0,0,0,2.63-.89l-2.27-30.64-21.86,4.28A1.91,1.91,0,0,1,117.53,381.54Z",
    style: {
      fill: "#F68989",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,381.54a6.45,6.45,0,0,1,5.28,2.91l15.88,24.24a1.43,1.43,0,0,0,2.63-.89l-2.27-30.64-21.86,4.28A1.91,1.91,0,0,1,117.53,381.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.77 151.14 144.84 423.14 402.19 374.1 341.71 161.97 122.77 151.14",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.7 157.01 149.86 408.76 391.86 364.76 340.85 169.17 134.7 157.01",
    style: {
      fill: "#F68989",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.49 280.9 161 400.23 380.88 360.25 360.45 270.56 149.49 280.9",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.93,
    y1: 394.29,
    x2: 188.28,
    y2: 355.96,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.58,
    y1: 388.36,
    x2: 222.06,
    y2: 356.41,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.57,
    y1: 381.97,
    x2: 254.46,
    y2: 356.41,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.56,
    y1: 376.14,
    x2: 287.67,
    y2: 345.67,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.5,
    y1: 370.74,
    x2: 318.33,
    y2: 341,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.21,
    y1: 365.43,
    x2: 345,
    y2: 329.67,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.68,285.49s-3.06,3.08-3.26,4.68,1.4,6.42,1.4,6.42l4.82.8,2.12-8.38Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.92,226.56s5.08,73.11,9.75,99.77S159,392.89,159,392.89s150-23.22,224-54.56l-6-28.66Z",
    style: {
      fill: "#F68989",
      opacity: 0.49,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,154.27l210.67,11.35s20.51,61.45,40.92,96.15,54.07,32.44,54.07,32.44-77.2,42.21-137.33,64.68c-62.58,23.37-116.85,27.57-116.85,27.57S131.19,318.94,129.14,154.27Z",
    style: {
      fill: "#F68989",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.26,143.33c-3.91,0-6.74,3.47-7.63,8.91l4,.22c.62-3.14,1.85-5.13,3.62-5.13,2.06,0,4.35,3.31,4.35,8.07s-2.29,8.08-4.35,8.08a2,2,0,0,0,0,4c4.68,0,8.35-5.31,8.35-12.08S157.94,143.33,153.26,143.33Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,158.64a13.75,13.75,0,0,1-.74,2.06",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61,150.44s1.5-5.42,5.93-5.12c3.48.24,6.35,5.41,5.87,10.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,145.08c-3.91,0-6.74,3.47-7.63,8.91l4,.22c.62-3.14,1.85-5.13,3.62-5.13,2.06,0,4.35,3.31,4.35,8.07s-2.29,8.08-4.35,8.08a2,2,0,0,0,0,4c4.68,0,8.35-5.31,8.35-12.08S192.69,145.08,188,145.08Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.75,160.39a13.75,13.75,0,0,1-.74,2.06",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.36,152.19s1.5-5.42,5.93-5.12c3.48.24,6.35,5.41,5.87,10.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.76,146.83c-3.91,0-6.74,3.47-7.63,8.91l4,.22c.62-3.14,1.85-5.13,3.62-5.13,2.06,0,4.35,3.31,4.35,8.07s-2.29,8.08-4.35,8.08a2,2,0,0,0,0,4c4.68,0,8.35-5.31,8.35-12.08S227.44,146.83,222.76,146.83Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,162.14a13.75,13.75,0,0,1-.74,2.06",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,153.94s1.5-5.42,5.93-5.12c3.48.24,6.35,5.41,5.87,10.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,148.58c-3.91,0-6.74,3.47-7.63,8.91l4,.22c.62-3.14,1.85-5.13,3.62-5.13,2.06,0,4.35,3.31,4.35,8.07s-2.29,8.08-4.35,8.08a2,2,0,0,0,0,4c4.68,0,8.35-5.31,8.35-12.08S262.19,148.58,257.51,148.58Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,163.89a13.75,13.75,0,0,1-.74,2.06",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.86,155.69s1.5-5.42,5.93-5.12c3.48.24,6.35,5.41,5.87,10.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.89,150.13c-3.91,0-6.74,3.47-7.62,8.92l4,.22c.63-3.14,1.86-5.14,3.62-5.14,2.06,0,4.36,3.32,4.36,8.08s-2.3,8.07-4.36,8.07a2,2,0,0,0,0,4c4.69,0,8.36-5.3,8.36-12.07S297.58,150.13,292.89,150.13Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.63,165.45a13.25,13.25,0,0,1-.74,2.05",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.24,157.25s1.51-5.43,5.93-5.13c3.49.24,6.35,5.42,5.88,10.95",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,152c-3.91,0-6.74,3.47-7.62,8.91l4,.23c.63-3.14,1.86-5.14,3.62-5.14,2.06,0,4.36,3.32,4.36,8.07s-2.3,8.08-4.36,8.08a2,2,0,0,0,0,4c4.69,0,8.36-5.31,8.36-12.08S331.57,152,326.88,152Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.62,167.26a13,13,0,0,1-.74,2.06",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,159.07s1.51-5.43,5.93-5.13c3.49.24,6.35,5.41,5.88,10.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.76,289s2,2.74,2,3.91-2.74,3.13-2.74,5.86-3.52,2-3.91,0,.78-4.69.78-4.69-1.63-1-2-4.52,2.8-2.52,2.8-2.52Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76,261.93c-14.49-24.64-29.71-63.55-35.12-77.87l-188.27-7.63c-.12,139.15,42,196.64,42,196.64s47.95-3.71,103.25-24.37c53.14-19.85,116.52-53.17,116.52-53.17S391.79,292.6,373.76,261.93Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.64,184.06l-188.27-7.63c0,13.69.39,26.57,1.11,38.7l198.82-1.86C345.15,201,341,190.25,338.64,184.06Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.97,
    y1: 225.54,
    x2: 350.87,
    y2: 225.23,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.81,
    y1: 226.43,
    x2: 335.3,
    y2: 225.76,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.14,
    y1: 227.5,
    x2: 309.19,
    y2: 226.65,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.92,
    y1: 228.59,
    x2: 278.61,
    y2: 227.69,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.77,
    y1: 229.65,
    x2: 245.24,
    y2: 228.82,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.95,
    y1: 230.77,
    x2: 212.44,
    y2: 229.93,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.06,
    y1: 231.75,
    x2: 181.85,
    y2: 230.97,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.35,
    y1: 253.2,
    x2: 362.48,
    y2: 240.58,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,251.42s3.4,55.08,39.71,116.22",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5,249.21s3.83,63,43.64,109.13",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,247.35s2,58,46.75,99.68",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,246s4.94,64.48,48.25,87.19",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,243.41s3.48,48.77,47.78,75.48",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.88,241.83s11.92,50,45.27,66.19",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.89,
    y1: 281.61,
    x2: 371.45,
    y2: 258.34,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.41,306.5s45.17-1.77,215.88-33.23",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,332.85s44,5,216.38-49.89",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.9,355.84s36.68,12.15,216.86-65",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69,203.65l-67.82-.91a2.27,2.27,0,0,1-2.22-2l-.58-5.48a2.24,2.24,0,0,1,2.26-2.48l67,1.16a2.26,2.26,0,0,1,2.15,1.7l1.36,5.21A2.24,2.24,0,0,1,231.69,203.65Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1462423029ba5f555a63d0448bf56fc6.svg";
export { ForwardRef as ReactComponent };